<template>
  <div id="out-content">
    <div id="content">
      <div id="left-content">
        <div class="center">
          <div id="title-1">六六书签</div>
          <div id="title-2">LIULIU &nbsp BOOKMARK</div>
        </div>
      </div>
      <div id="right-content">
        <div id="form-content">
          <div id="title-3">登录</div>
          <div id="input-group">
            <a-form :form="form" @submit="handleSubmit" hideRequiredMark>
              <a-form-item v-bind="formItemLayout" class="input-small-margin">
                <span slot="label">
                  <a-icon
                    type="user"
                    :style="{ fontSize: '16px', color: '#08c' }"
                  />
                </span>
                <a-input
                  placeholder="请输入您的登录名/邮箱"
                  v-decorator="[
                    'userName',
                    {
                      rules: [
                        {
                          required: true,
                          message: '请输入您的昵称',
                          whitespace: true,
                        },
                      ],
                    },
                  ]"
                />
              </a-form-item>
              <a-form-item
                v-bind="formItemLayout"
                has-feedback
                class="input-small-margin"
              >
                <span slot="label">
                  <a-icon
                    type="unlock"
                    :style="{ fontSize: '16px', color: '#08c' }"
                  />
                </span>
                <a-input
                  placeholder="请输入您的密码"
                  v-decorator="[
                    'password',
                    {
                      rules: [
                        {
                          required: true,
                          message: '请输入您的密码!',
                        },
                      ],
                    },
                  ]"
                  type="password"
                />
              </a-form-item>

              <a-form-item v-bind="tailFormItemLayout">
                <a-checkbox
                  v-decorator="[
                    'remember',
                    {
                      valuePropName: 'checked',
                      initialValue: true,
                    },
                  ]"
                >
                  <span class="small-font-w">记住账号</span>
                </a-checkbox>
                <router-link class="login-form-forgot" to="">
                  忘记密码
                </router-link>
                <a-button
                  type="primary"
                  html-type="submit"
                  :style="{ width: '85%' }"
                >
                  登录
                </a-button>
                <router-link to="/register">
                  <div id="btn-text">注册账号</div>
                </router-link>
              </a-form-item>
            </a-form>
          </div>
        </div>
      </div>
    </div>
    <div class="icp">
      <a href="https://beian.miit.gov.cn"> 蜀ICP备2020032747号-1</a>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      formItemLayout: {
        labelCol: {
          xs: { span: 24 },
          sm: { span: 4 },
        },
        wrapperCol: {
          xs: { span: 2 },
          sm: { span: 18 },
        },
      },
      tailFormItemLayout: {
        wrapperCol: {
          xs: {
            span: 46,
            offset: 4,
          },
          sm: {
            span: 24,
            offset: 2,
          },
        },
      },
      preUrl:''
    };
  },
  beforeCreate() {
    this.form = this.$form.createForm(this, { name: "normal_login" });
  },
  beforeRouteEnter (to, from, next){
    next(vm=>{
        vm.preUrl = from.fullPath;
    });
  },
  methods: {
    handleSubmit(e) {
      e.preventDefault();
      this.form.validateFields((err, values) => {
        if (!err) {
          this.$req.post(
            "/api/user/login?reuser=" + values.remember,
            values,
            (res) => {
              this.$req.get("/api/user/info", {}, (res) => {
                this.$store.commit("initUser", res.data);
              });
              this.$message.success("登录成功！");
              if(this.preUrl && this.preUrl != '/register'){
                this.$router.push(this.preUrl);
              }else{
                this.$router.push("/");
              }
            }
          );
        }
      });
    },
  },
};
</script>
<style>
#out-content {
  width: 100%;
  height: 100%;
  position: relative;
  background-image: url("../../assets/img/image4.png");
}

#content {
  width: 866px;
  height: 533px;
  position: absolute;
  margin: auto;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
}

#left-content {
  width: 466px;
  height: 100%;
  float: left;
  background-color: #19a0fb;
  opacity: 0.6;
  border-top-left-radius: 30px;
  border-bottom-left-radius: 30px;
}

#right-content {
  width: 400px;
  height: 100%;
  float: left;
  background-color: #ffffff;
  border-top-right-radius: 30px;
  border-bottom-right-radius: 30px;
}

.center {
  width: 184px;
  height: 66px;
  margin: auto;
  margin-top: 45%;
}
#title-1 {
  font-family: FZLanTingHei-R-GBK;
  font-style: normal;
  font-weight: normal;
  font-size: 26px;
  line-height: 46px;
  /* identical to box height */

  letter-spacing: 0.4em;
  text-align: left;
  color: #ffffff;
}
#title-2 {
  font-family: FZLanTingHei-R-GBK;
  font-style: normal;
  font-weight: normal;
  font-size: 10px;
  line-height: 18px;
  letter-spacing: 0.1em;

  color: #ffffff;
  text-align: left;
  opacity: 0.5;
}

#title-3 {
  font-family: FZLanTingHei-R-GBK;
  font-style: normal;
  font-weight: normal;
  font-size: 26px;
  line-height: 46px;
  color: #19a0fb;
  text-align: center;
  margin-bottom: 22px;
}

#form-content {
  width: 266px;
  height: 400px;
  margin: 67px 67px 0 67px;
}
#input-group {
  width: 266px;
  height: 236px;
}
.input-small-margin {
  margin-bottom: 12px !important;
}
#get-code {
  font-family: FZLanTingHei-R-GBK;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 18px;
  color: #19a0fb;
}
#btn-text {
  font-family: FZLanTingHei-R-GBK;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 18px;
  color: #19a0fb;
}
.small-font-w {
  font-family: FZLanTingHei-R-GBK;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 18px;
  color: #999999;
}
.login-form-forgot {
  margin-left: 80px;
  font-family: FZLanTingHei-R-GBK;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 18px;
  color: #999999;
}
.icp{
  position: absolute;
  bottom: 0;
  left: 42%;
  font-size: 20px;
}
</style>